import { CLIENT_DOCUMENT_ISSUED_BY } from '../constants';

// В карточке орган хранится кодом (1 — МВД РК, 2 — МЮ РК), а ПКБ присылал его названием, русским или
// казахским («ҚР ІШКІ ІСТЕР МИНИСТРЛІГІ») — приводим к справочнику.
export const resolveIssuer = (raw) => {
  if (raw === null || raw === undefined || raw === '') return undefined;

  const byCode = CLIENT_DOCUMENT_ISSUED_BY.find((item) => item.value === Number(raw));
  if (byCode) return byCode;

  const text = String(raw).toLowerCase();
  if (text.includes('внутренн') || text.includes('мвд') || text.includes('ішкі істер')) {
    return CLIENT_DOCUMENT_ISSUED_BY[0];
  }
  if (text.includes('юстиц') || text.includes('әділет') || text.includes('мю')) return CLIENT_DOCUMENT_ISSUED_BY[1];
  return undefined;
};
